import type { AppcuesType } from './types';

type WindowType = {
  Appcues?: AppcuesType;
};

const useAppcues = () => {
  const { Appcues } = window as WindowType;

  const mockMethod = (): void => null;

  const mockIndentify = () => {
    console.log('Please disable adblock to enable Appcues');
  };

  // In some cases, adblockers might block Appcues from initializing, making it undefined
  // so we have to account for that. But the error probably won't be caught in qa/debugging
  // so it's better to have a mock object that does nothing instead of the entire page breaking.
  const MockAppcues: AppcuesType = {
    page: mockMethod,
    identify: mockIndentify,
    track: mockMethod,
    show: mockMethod,
    clearShow: mockMethod,
    on: mockMethod,
    off: mockMethod,
    once: mockMethod,
    reset: mockMethod,
    debug: mockMethod,
    loadLaunchpad: mockMethod,
  };

  return Appcues || MockAppcues;
};

export { AppcuesType, AppcuesEventType } from './types';
export default useAppcues;
